var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-container" },
    [
      _c(
        "form-wrapper",
        { staticClass: "modal-form", attrs: { validator: _vm.$v.rateDetail } },
        [
          _c("header", { staticClass: "modal-header" }, [
            _c(
              "div",
              { staticClass: "modal-header__right" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-simple md-just-icon md-round",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.$modal.hide($event)
                      },
                    },
                  },
                  [_c("md-icon", [_vm._v("clear")])],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("section", { staticClass: "modal-section" }, [
            _c(
              "div",
              { staticClass: "section-override" },
              [
                _c(
                  "md-switch",
                  {
                    model: {
                      value: _vm.rateDetail.overrideRule,
                      callback: function ($$v) {
                        _vm.$set(_vm.rateDetail, "overrideRule", $$v)
                      },
                      expression: "rateDetail.overrideRule",
                    },
                  },
                  [_vm._v("\n                   Override\n                ")]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "section-heading" }, [
              _c("span", { staticClass: "section-heading__badge" }, [
                _vm._v("Timeframe"),
              ]),
              _c("p", { staticClass: "section-heading__copy" }, [
                _vm._v("Choose when the waiting time rule applies."),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "section-card section-card--wide" },
              [
                _c("rule-valid-days", {
                  ref: "ruleValidDays",
                  attrs: {
                    "current-days": _vm.rateDetail.validForWeekDays,
                    "from-date": _vm.rateDetail.validFromDate,
                    "to-date": _vm.rateDetail.validToDate,
                  },
                  on: { daysSelected: _vm.handleDaysSeleceted },
                }),
              ],
              1
            ),
          ]),
          _c("section", { staticClass: "modal-section" }, [
            _c("div", { staticClass: "section-heading" }, [
              _c("span", { staticClass: "section-heading__badge" }, [
                _vm._v("Charging"),
              ]),
              _c("p", { staticClass: "section-heading__copy" }, [
                _vm._v(
                  "Set included minutes, billing intervals and hourly rates."
                ),
              ]),
            ]),
            _c("div", { staticClass: "section-card section-card--compact" }, [
              _c("div", { staticClass: "charging-grid" }, [
                _c("div", { staticClass: "charging-group" }, [
                  _c("h5", { staticClass: "charging-group__title" }, [
                    _vm._v("Included time"),
                  ]),
                  _c("p", { staticClass: "charging-group__hint" }, [
                    _vm._v("Minutes included before additional charges apply."),
                  ]),
                  _c(
                    "div",
                    { staticClass: "field-pair" },
                    [
                      _c(
                        "form-group",
                        {
                          attrs: {
                            name: "includedWaitingTime",
                            label: "Included",
                          },
                        },
                        [
                          _vm.$_nullChecker(_vm.rateDetail.includedWaitingTime)
                            ? _c("rule-operator", {
                                attrs: {
                                  value:
                                    _vm.rateDetail.includedWaitingTime.operator,
                                },
                                model: {
                                  value:
                                    _vm.rateDetail.includedWaitingTime.operator,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rateDetail.includedWaitingTime,
                                      "operator",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "rateDetail.includedWaitingTime.operator",
                                },
                              })
                            : _vm._e(),
                          _c("md-input", {
                            model: {
                              value: _vm.rateDetail.includedWaitingTime.value,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.rateDetail.includedWaitingTime,
                                  "value",
                                  _vm._n($$v)
                                )
                              },
                              expression:
                                "rateDetail.includedWaitingTime.value",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "form-group",
                        {
                          attrs: {
                            name: "waitTimeInterval",
                            label: "Interval",
                          },
                        },
                        [
                          _vm.$_nullChecker(_vm.rateDetail.waitTimeInterval)
                            ? _c("rule-operator", {
                                attrs: {
                                  value:
                                    _vm.rateDetail.waitTimeInterval.operator,
                                },
                                model: {
                                  value:
                                    _vm.rateDetail.waitTimeInterval.operator,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rateDetail.waitTimeInterval,
                                      "operator",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "rateDetail.waitTimeInterval.operator",
                                },
                              })
                            : _vm._e(),
                          _c("md-input", {
                            model: {
                              value: _vm.rateDetail.waitTimeInterval.value,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.rateDetail.waitTimeInterval,
                                  "value",
                                  _vm._n($$v)
                                )
                              },
                              expression: "rateDetail.waitTimeInterval.value",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", {
                  staticClass: "charging-separator",
                  attrs: { "aria-hidden": "true" },
                }),
                _c("div", { staticClass: "charging-group" }, [
                  _c("h5", { staticClass: "charging-group__title" }, [
                    _vm._v("Rates"),
                  ]),
                  _c("p", { staticClass: "charging-group__hint" }, [
                    _vm._v("Define hourly and interval charges."),
                  ]),
                  _c(
                    "div",
                    { staticClass: "field-pair" },
                    [
                      _c(
                        "form-group",
                        { attrs: { name: "ratePerHour", label: "Per Hour" } },
                        [
                          _vm.$_nullChecker(
                            _vm.rateDetail.waitingTimeRatePerHour
                          )
                            ? _c("rule-operator", {
                                attrs: {
                                  value:
                                    _vm.rateDetail.waitingTimeRatePerHour
                                      .operator,
                                },
                                model: {
                                  value:
                                    _vm.rateDetail.waitingTimeRatePerHour
                                      .operator,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rateDetail.waitingTimeRatePerHour,
                                      "operator",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "rateDetail.waitingTimeRatePerHour.operator",
                                },
                              })
                            : _vm._e(),
                          _c("md-input", {
                            model: {
                              value:
                                _vm.rateDetail.waitingTimeRatePerHour.value,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.rateDetail.waitingTimeRatePerHour,
                                  "value",
                                  _vm._n($$v)
                                )
                              },
                              expression:
                                "rateDetail.waitingTimeRatePerHour.value",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "form-group",
                        {
                          attrs: {
                            name: "WaitTimeRatePerInterval",
                            label: "Per Interval",
                          },
                        },
                        [
                          _vm.$_nullChecker(
                            _vm.rateDetail.waitTimeRatePerInterval
                          )
                            ? _c("rule-operator", {
                                attrs: {
                                  value:
                                    _vm.rateDetail.waitTimeRatePerInterval
                                      .operator,
                                },
                                model: {
                                  value:
                                    _vm.rateDetail.waitTimeRatePerInterval
                                      .operator,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rateDetail.waitTimeRatePerInterval,
                                      "operator",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "rateDetail.waitTimeRatePerInterval.operator",
                                },
                              })
                            : _vm._e(),
                          _c("md-input", {
                            model: {
                              value:
                                _vm.rateDetail.waitTimeRatePerInterval.value,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.rateDetail.waitTimeRatePerInterval,
                                  "value",
                                  _vm._n($$v)
                                )
                              },
                              expression:
                                "rateDetail.waitTimeRatePerInterval.value",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", {
                  staticClass: "charging-separator",
                  attrs: { "aria-hidden": "true" },
                }),
                _c(
                  "div",
                  { staticClass: "charging-group" },
                  [
                    _c("h5", { staticClass: "charging-group__title" }, [
                      _vm._v("Descriptor"),
                    ]),
                    _c("p", { staticClass: "charging-group__hint" }, [
                      _vm._v("Text shown on invoices or reports."),
                    ]),
                    _c(
                      "form-group",
                      {
                        attrs: {
                          name: "waitTimeDescription",
                          label: "Description",
                        },
                      },
                      [
                        _c("md-input", {
                          model: {
                            value: _vm.rateDetail.waitTimeDescription,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.rateDetail,
                                "waitTimeDescription",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "rateDetail.waitTimeDescription",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _c("footer", { staticClass: "modal-footer" }, [
            _c(
              "div",
              { staticClass: "modal-footer__actions" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-default dialog-button",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.$modal.hide($event)
                      },
                    },
                  },
                  [_vm._v("Cancel")]
                ),
                _c(
                  "md-button",
                  {
                    staticClass: "md-primary dialog-button",
                    on: {
                      click: function ($event) {
                        return _vm.saveForm()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.isUpdate ? "Update" : "Create") +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }